import React from "react";
import { LazyLoadImages, ResponsiveImage } from "@quintype/components";
import PropTypes from "prop-types";
import get from "lodash/get";
import "./also-read.module.css";
import { connect } from "react-redux";
import { CustomLink } from "../../custom-link";
import { ImageFallback } from "../../basic/image-fallback";
import { altTagOfHeroImages } from "../../../../isomorphic/utils";

const AlsoReadBase = ({ story, element, template = "", elementAlignment, externalLink = false, index }) => {
  const linkedStories = get(story, ["linked-stories"], {});
  const linkedStoryId = get(element, ["metadata", "linked-story-id"]);
  const linkedStorySlug = get(linkedStories, [linkedStoryId, "slug"]);
  const linkedImage = get(linkedStories, [linkedStoryId, "hero-image-s3-key"]);
  const storyUrl = `/${linkedStorySlug}`;
  const supportedTemplates = ["default", "vertical"];
  const getTemplate = template && `wrapper--${template}`;
  const templateStyle = supportedTemplates.includes(template) ? `card-content  ${getTemplate} ` : "card-content";
  let text = element.text || "";
  if (externalLink) {
    text = element.text.replace(/<a/g, '<a target="_blank"');
  }

  const elementStyle = (elementAlignment, index) => {
    const isAlign = {
      0: {
        left: "left",
        right: "right"
      }
    };

    return get(isAlign, [index, elementAlignment], "");
  };

  return (
    <CustomLink
      href={storyUrl}
      data-testid="also-read-element"
      styleName={`wrapper--${template} ${templateStyle} ${elementStyle(elementAlignment, index)}`}
    >
      <span data-testid="also-read-text" styleName="default-text">
        Also Read
      </span>
      <div data-testid="also-read-image" styleName="card-image-wrapper">
        {linkedImage ? (
          <figure styleName="card-image">
            <LazyLoadImages margin={"0px"}>
              <ResponsiveImage
                slug={linkedImage}
                metadata={{}}
                aspect-ratio={[16, 9]}
                defaultWidth={480}
                widths={[250, 480, 640]}
                imgParams={{ auto: ["format", "compress"] }}
                alt={altTagOfHeroImages(story)}
              />
            </LazyLoadImages>
          </figure>
        ) : (
          <ImageFallback story={story} />
        )}
      </div>
      <div styleName="content-wrapper">
        <span data-testid="Also-read-text" styleName="text">
          Also Read
        </span>
        <div data-testid="also-read-headline" styleName="headline" dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </CustomLink>
  );
};

const mapStateToProps = state => ({
  template: get(state, ["qt", "config", "theme-attributes", "also-read-element"], "default")
});

export const AlsoRead = connect(mapStateToProps)(AlsoReadBase);

AlsoReadBase.propTypes = {
  template: PropTypes.oneOf(["default", "vertical"]),
  story: PropTypes.object,
  element: PropTypes.object,
  elementAlignment: PropTypes.string,
  externalLink: PropTypes.bool,
  index: PropTypes.string
};
